class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

//  Progress bar 

function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

let isUpdating = false;

function initProgress() {
  if (isUpdating) return;

  const wrapper = document.querySelector('[data-cart-progress]');
  if (!wrapper) return;

  const subtotal = wrapper.dataset.progressSubtotal;
  if (!subtotal) return;

  isUpdating = true;

  const fill = wrapper.querySelector('[data-progress-fill]');
  const text = wrapper.querySelector('[data-progress-text]');
  const save = wrapper.querySelector('[data-progress-save]');
  const steps = [...wrapper.querySelectorAll('.cart-progress-step')];

  let currentTier = null;
  let nextTier = null;

  // Reset states
  steps.forEach(step => {
    step.classList.remove('active', 'completed');
  });

  // Determine tiers
  for (let i = 0; i < steps.length; i++) {
    const threshold = Number(steps[i].dataset.threshold);

    if (subtotal < threshold) {
      nextTier = {
        el: steps[i],
        threshold,
        discount: steps[i].dataset.discount
      };
      break;
    }

    currentTier = {
      el: steps[i],
      threshold,
      discount: steps[i].dataset.discount
    };
  }

  // Apply completed state
  steps.forEach(step => {
    const threshold = Number(step.dataset.threshold);
    if (subtotal >= threshold) {
      step.classList.add('completed');
    }
  });

  // Apply active state
  if (nextTier) {
    nextTier.el.classList.add('active');
  }

  // Progress calculation
  let progress = 100;

  if (nextTier) {
    const prevThreshold = currentTier ? currentTier.threshold : 0;

    const prevStep = currentTier ? currentTier.el : null;
    const nextStep = nextTier.el;

    const prevLeft = prevStep ? prevStep.offsetLeft : 0;
    const nextLeft = nextStep.offsetLeft;

    const range = nextTier.threshold - prevThreshold;
    const progressInRange = subtotal - prevThreshold;

    const ratio = progressInRange / range;

    const barWidth = wrapper.querySelector('.cart-progress-bar').offsetWidth;

    const prevPercent = (prevLeft / barWidth) * 100;
    const nextPercent = (nextLeft / barWidth) * 100;

    progress = prevPercent + (nextPercent - prevPercent) * ratio;
  }

  fill.style.width = Math.min(progress, 100) + "%";

  // Messaging
  if (!nextTier && currentTier) {
    text.innerHTML = `You've unlocked the maximum discount`;
  } else if (nextTier) {
    const diff = nextTier.threshold - subtotal;
    text.innerHTML = `You're <strong>${formatMoney(diff)}</strong> away from <strong>${nextTier.discount}</strong> off`;
  }

  // Savings calculation
  let savings = 0;

  if (currentTier && currentTier.discount) {
    const discountValue = parseFloat(currentTier.discount.replace('%', '')) || 0;
    savings = Math.round(subtotal * (discountValue / 100));
  }

  if (save) {
    save.innerHTML = savings > 0
      ? `<strong>${formatMoney(savings)}</strong> saved!`
      : '';
  }

  setTimeout(() => {
    isUpdating = false;
  }, 100);
}

/* -----------------------------
   SAFE EVENT HOOKS
----------------------------- */

// Initial load
// document.addEventListener('cartdrawer:opened', initProgress);

// Theme events (if available)
['cartdrawer:opened', 'cart:updated', 'cart:added', 'ajaxProduct:added'].forEach(event => {
  document.addEventListener(event, initProgress);
});